"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateFormatter = exports.getFiscalYearStartMonth = exports.getMeasureFormatString = exports.getTimestampGranularity = exports.buildMeasureAccessor = exports.buildTimestampAccessor = exports.getMeasureFeature = exports.getTimestampFeature = exports.MEASURE_COLUMN_NAME = exports.TIMESTAMP_COLUMN_NAME = void 0;
var dateFormatter_1 = require("../formatting/dateFormatter");
var models_1 = require("../models");
var EffectiveDefinition_1 = require("../models/EffectiveDefinition");
exports.TIMESTAMP_COLUMN_NAME = 'timestamp';
exports.MEASURE_COLUMN_NAME = 'measure';
var getTimestampFeature = function (features) {
    return features.timestamp;
};
exports.getTimestampFeature = getTimestampFeature;
var getMeasureFeature = function (features) {
    return features.measure;
};
exports.getMeasureFeature = getMeasureFeature;
var buildTimestampAccessor = function (effectiveDefinition) {
    var timestamp = (0, exports.getTimestampFeature)(effectiveDefinition.features);
    return function (dataRow) { return dataRow[timestamp === null || timestamp === void 0 ? void 0 : timestamp.column]; };
};
exports.buildTimestampAccessor = buildTimestampAccessor;
var buildMeasureAccessor = function (effectiveDefinition) {
    var measure = (0, exports.getMeasureFeature)(effectiveDefinition.features);
    return function (dataRow) { return dataRow[measure.column]; };
};
exports.buildMeasureAccessor = buildMeasureAccessor;
var getTimestampGranularity = function (effectiveDefinition) {
    var _a;
    var timestamp = (0, exports.getTimestampFeature)(effectiveDefinition.features);
    var column = (0, EffectiveDefinition_1.columnSchemaForRef)(effectiveDefinition, timestamp);
    return (_a = column === null || column === void 0 ? void 0 : column.dateGranularity) !== null && _a !== void 0 ? _a : models_1.DateGranularity.UNKNOWN;
};
exports.getTimestampGranularity = getTimestampGranularity;
var getMeasureFormatString = function (definition) {
    var measure = (0, exports.getMeasureFeature)(definition.features);
    var column = (0, EffectiveDefinition_1.columnSchemaForRef)(definition, measure);
    if (!(0, EffectiveDefinition_1.isNumericColumnSchema)(column)) {
        return undefined;
    }
    return column.format;
};
exports.getMeasureFormatString = getMeasureFormatString;
var getFiscalYearStartMonth = function (definition) {
    var timestamp = definition && (0, exports.getTimestampFeature)(definition.features);
    var column = definition && timestamp && (0, EffectiveDefinition_1.columnSchemaForRef)(definition, timestamp);
    return (column === null || column === void 0 ? void 0 : column.fiscalYearStartMonth) || models_1.FiscalYearStartMonth.JANUARY;
};
exports.getFiscalYearStartMonth = getFiscalYearStartMonth;
var getDateFormatter = function (definition) {
    var granularity = definition ? (0, exports.getTimestampGranularity)(definition) : models_1.DateGranularity.UNKNOWN;
    var dateTrunc = (0, models_1.dateTruncFromGranularity)(granularity);
    var fiscalYearStartMonth = (0, exports.getFiscalYearStartMonth)(definition);
    return (0, dateFormatter_1.dateFormatterFactory)(dateTrunc, fiscalYearStartMonth);
};
exports.getDateFormatter = getDateFormatter;
//# sourceMappingURL=metricValue.js.map